import { TCellComponent } from '../List';
import { FormattedDate } from '@plone/volto/components';
import React from 'react';

const ModifiedCellContent: TCellComponent<string | undefined> = ({ data }) =>
  data != null ? (
    <FormattedDate
      date={data}
      format={{ year: 'numeric', month: 'short', day: 'numeric' }}
      long={false}
      includeTime={false}
      relative={false}
      className=""
      locale={false}
      children={false}
    />
  ) : null;

export default ModifiedCellContent;
